import { TealiumConstants } from '../constants/tealium.constants';
import { TealiumAnalyticsEvent } from '../models/tealium-analytics-event';

export class TrackEventUtil {
	/**
	 * @param linkName
	 * @param ids current portfolio ids after portfolio change
	 * @param idPropName property name(key) in event to store id that is changed
	 * @param idChanged portfolio id that is changed
	 */
	public static createPortfolioChangeEvent(linkName: string, ids: string, idPropName: string, idChanged?: string): TealiumAnalyticsEvent {
		const event = {
			linkName,
			portfolioIds: ids
		};
		if (idPropName === TealiumConstants.EVENT_PROPERTY_NAMES.PORTFOLIO_ADDED) {
			if (idChanged) {
				event[idPropName] = idChanged;
			} else {
				const idArray = ids.split(',');
				event[idPropName] = idArray[idArray.length - 1];
			}
		} else if (idPropName === TealiumConstants.EVENT_PROPERTY_NAMES.PORTFOLIO_REMOVED) {
			event[idPropName] = idChanged;
		}
		return new TealiumAnalyticsEvent(TealiumConstants.TOOLS_EVENT.NEW_URL, event);
	}
}
